import * as React from 'react';
import { PhoneButton } from '../../components/PhoneButton';
import { formatPhone, hidePhone } from '../../utils';

export interface IPhoneButtonContainerProps {
  phone: string;
  placeholder?: string;
  onShow?(): void;
}

export const PhoneButtonContainer: React.VFC<IPhoneButtonContainerProps> = ({ phone, placeholder, onShow }) => {
  const [phoneVisible, setPhoneVisible] = React.useState(false);

  const formattedPhone = React.useMemo(() => {
    return formatPhone(phone);
  }, [phone]);

  const hiddenPhone = React.useMemo(() => {
    return placeholder || hidePhone(formattedPhone);
  }, [placeholder, formattedPhone]);

  const handleShowPhone = React.useCallback(() => {
    setPhoneVisible(true);

    if (onShow) {
      onShow();
    }
  }, [onShow]);

  return (
    <PhoneButton
      phoneVisible={phoneVisible}
      phone={formattedPhone}
      placeholder={hiddenPhone}
      showPhone={handleShowPhone}
    />
  );
};
